import styled from "styled-components";

import { typography } from "globalConstants";
import { Default } from "Types";
import { logo } from "images";

export type PropsType = Default;

const Wrap = styled.div<Default>`
   margin-top: 40px;
   position: relative;
   padding: 5px 7px;
`;
const ContentWrap = styled.div`
   display: flex;
   position: relative;
   align-items: center;
   column-gap: 15px;
`;

const Img = styled.img`
   height: 21px;
`;
const Text = styled.div`
   ${typography.other.h1}
`;

export default function AtomTitle(props: PropsType) {
   return (
      <Wrap className={props.className}>
         <ContentWrap>
            <Img src={logo}></Img>
            <Text>{props.children}</Text>
         </ContentWrap>
      </Wrap>
   );
}
